<template>
  <ContentInfoLinks :links="links" />
</template>

<script>
import ContentInfoLinks from 'chimera/all/themes/blueflow/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      links: [
        {
          title: 'Algemeen',
          to: '/informatie-over-ramen/',
        },
        {
          title: 'Houten ramen',
          to: '/informatie-over-ramen/hout',
        },
        {
          title: 'Aluminium ramen',
          to: '/informatie-over-ramen/aluminium',
        },
        {
          title: 'PVC ramen',
          to: '/informatie-over-ramen/pvc',
        },
      ],
    }
  },
}
</script>
